import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import { useTheme } from '@unisporkal/themes';
import { modalInteraction, ga4Track } from '@unisporkal/ga4';
import { batchSizeType } from '../../../../types/sizeType';
import styles from '../AssetSizes.module.scss';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex.ts';
import { useAsset } from '../../../../hooks/stateful/useAsset';

const BatchSize = ({ size, index }) => {
  const { assets } = useAsset();
  const t = useTranslations();
  const theme = useTheme();
  const themeRadio = theme.radio || {};
  const { selectedSizeIndex, setSelectedSizeIndex } = useSelectedIndex();
  const isSelected = selectedSizeIndex === index;

  const getGa4ModalSelectionValue = () => {
    const allVideo = assets.every((asset) => asset.isFilm());
    const allImage = assets.every((asset) => !asset.isFilm());
    let mediaTypes = 'mix';
    if (allVideo) {
      mediaTypes = 'video';
    }
    if (allImage) {
      mediaTypes = 'image';
    }

    let optionSize = size.name;
    if (size.name.indexOf('smallest') === 0) {
      optionSize = 'smallest';
    }
    if (size.name.indexOf('largest') === 0) {
      optionSize = 'largest';
    }

    return `${optionSize}_size_${mediaTypes}`;
  };

  const trackSelectedSizeChanged = () => {
    const modalEvent = modalInteraction({
      event: 'modal_select_option',
      modal_content: 'download_options',
      modal_type: 'selectors_cta_modal',
      cta_text: size.label,
      ui_element_location: 'modal_cta',
      modal_selection: getGa4ModalSelectionValue(),
    });

    ga4Track(modalEvent);
  };

  const handleClick = () => {
    setSelectedSizeIndex(index);
    trackSelectedSizeChanged();
  };

  return (
    <label
      className={isSelected ? styles.selectedSizeItem : styles.sizeItem}
      data-testid="asset-size"
    >
      <div
        className={styles.itemDetails}
        data-testid="batch-size"
      >
        <input
          className={cx(themeRadio.radioButton, styles.radio)}
          type="radio"
          checked={isSelected}
          id={size.label}
          onChange={handleClick}
        />
        <div className={styles.description}>
          <span
            className={styles.name}
            htmlFor={size.label}
          >
            {t(size.label)}
          </span>
          {isSelected && size.hasFileSize && (
            <div className={styles.sizeDetails}>
              <div className={styles.info}>
                {t('size_total', { size: size.fileSize })}
              </div>
            </div>
          )}
        </div>
      </div>
    </label>
  );
};

BatchSize.propTypes = {
  size: batchSizeType.isRequired,
  index: PropTypes.number.isRequired,
};

export default BatchSize;
